/**
 * Base object: defines an entity's schema (fields + which are editable/displayed).
 * The schema drives both rendering and the editor. Modules extend and declare
 * their own fields.
 */
export default class BaseObject {
  static fields = [];

  constructor(data = {}) {
    Object.assign(this, data);
  }

  /** Field definitions — override: [{ key, type, section, editable, label }]. */
  static schema() {
    return this.fields;
  }
}
